import PropTypes from 'prop-types';

const DocumentSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M34.1641 16.9833H29.3474C25.3974 16.9833 22.1807 13.7667 22.1807 9.81668V5.00001C22.1807 4.08334 21.4307 3.33334 20.5141 3.33334H13.4474C8.31406 3.33334 4.16406 6.66668 4.16406 12.6167V27.3833C4.16406 33.3333 8.31406 36.6667 13.4474 36.6667H26.5474C31.6807 36.6667 35.8307 33.3333 35.8307 27.3833V18.65C35.8307 17.7333 35.0807 16.9833 34.1641 16.9833Z"
        fill={color}
      />
      <path
        d="M26.3354 3.68334C25.6521 3.00001 24.4688 3.46668 24.4688 4.41668V10.2333C24.4688 12.6667 26.5354 14.6833 29.0521 14.6833C30.6354 14.7 32.8354 14.7 34.7188 14.7C35.6687 14.7 36.1687 13.5833 35.5021 12.9167C33.1021 10.5 28.8021 6.15001 26.3354 3.68334Z"
        fill={color}
      />
      <path
        d="M22.5 22.9167H12.5C11.8167 22.9167 11.25 22.35 11.25 21.6667C11.25 20.9833 11.8167 20.4167 12.5 20.4167H22.5C23.1833 20.4167 23.75 20.9833 23.75 21.6667C23.75 22.35 23.1833 22.9167 22.5 22.9167Z"
        fill={color}
      />
      <path
        d="M19.1667 29.5833H12.5C11.8167 29.5833 11.25 29.0167 11.25 28.3333C11.25 27.65 11.8167 27.0833 12.5 27.0833H19.1667C19.85 27.0833 20.4167 27.65 20.4167 28.3333C20.4167 29.0167 19.85 29.5833 19.1667 29.5833Z"
        fill={color}
      />
    </svg>
  );
};

DocumentSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DocumentSvg;
